import { EllipsisHorizontal } from '@squareup/dex-icons/market/action';
import { commonIconStyles } from '@squareup/dex-ui-shared-icon-styles';
import { MarketAccessory, MarketButton } from '@squareup/dex-ui-shared-market';
import clsx from 'clsx';
import React, { AriaAttributes, FC, MouseEventHandler } from 'react';

import styles from './combobox.module.css';

interface Props {
  onClick?: MouseEventHandler<globalThis.HTMLMarketButtonElement>;
}

const ComboboxExtrasButton: FC<Props & AriaAttributes> = ({
  onClick,
  ...rest
}) => {
  return (
    <MarketButton
      onClick={onClick}
      className={clsx(styles['extras-button'])}
      rank="secondary"
      size="small"
      testId="combobox-extras-button"
      trackingId="combobox-extras-button"
      aria-label="Field extras button"
      aria-haspopup="listbox"
      {...rest}
    >
      <MarketAccessory slot="icon">
        <EllipsisHorizontal className={commonIconStyles['icon-color-20']} />
      </MarketAccessory>
    </MarketButton>
  );
};

export { ComboboxExtrasButton };
